import React, { useEffect, useState, useRef, useCallback } from "react";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import {
  getfundRequestReportService,
  getpaySlipPreviewService,
  handleFormSTatusService,
} from "../../../services/walletservice";
import Loader from "../../../components/Loader/Loader";
import PopMenu from "../../../components/Dialog/PopMenu";
import Button from "../../Components/ButtonComponent/Button";
import { showSuccessToast } from "../../../utils/toastUtils";
import ImageSketlton from "../../../components/Loader/ImageSkelton";
import {
  FaInbox,
  FaUsers,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaRupeeSign,
  FaCheck,
  FaTimes,
} from "react-icons/fa";

const FundApprove = () => {
  const [fundRequestReport, setFundRequestReport] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totaldata, setTotalData] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [approvePopUp, setApprovePopUp] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [amount, setAmount] = useState();
  const [selectedName, setSelectedName] = useState("");
  const [paySlip, setPaySlip] = useState("");
  const [filename, setFileName] = useState("");
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [selectedFundId, setSelectedFundId] = useState("");

  // Filter states
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    status: "",
    user_id: "",
  });

  // Debounce timer ref
  const debounceTimerRef = useRef(null);

  async function getPaySlipPreview() {
    setIsImagePreview(true);
    const response = await getpaySlipPreviewService(filename);
    setPaySlip(response.dataUri);
    setIsImagePreview(false);
  }

  async function getFundRequestReport(page = 1) {
    try {
      setIsLoading(true);
      const filterData = {
        total_data: totaldata,
        from_date: filters.from_date || null,
        to_date: filters.to_date || null,
        status: filters.status || null,
        user_id: filters.user_id || null,
      };

      const response = await getfundRequestReportService(filterData, page);
      setIsLoading(false);
      setFundRequestReport(response?.data?.data || {});
      setPaginationData(response?.data?.pagination);
      setCurrentPage(page);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  async function handleFundStatus(statuus) {
    try {
      const response = await handleFormSTatusService(
        selectedFundId,
        statuus,
        remarks,
      );

      if (response.status.code === 200) {
        showSuccessToast(response.message);
        setFileName("");
        setPaySlip("");
        setSelectedFundId("");
        setRemarks("");
        setApprovePopUp(false);
        getFundRequestReport(currentPage);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle search button click
  const handleSearch = () => {
    setCurrentPage(1);
    getFundRequestReport(1);
  };

  // Handle reset filters
  const handleResetFilters = () => {
    setFilters({
      from_date: "",
      to_date: "",
      status: "",
      user_id: "",
    });
    setCurrentPage(1);
    setTotalData(10);
    // Clear debounce timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  };

  // Debounced search for user_id (triggers after 3 characters)
  useEffect(() => {
    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Only trigger search if user_id has 3 or more characters
    if (filters.user_id.length === 8) {
      debounceTimerRef.current = setTimeout(() => {
        setCurrentPage(1);
        getFundRequestReport(1);
      }, 1000); // 500ms delay
    } else if (filters.user_id.length === 0) {
      // If user clears the input, fetch all records
      debounceTimerRef.current = setTimeout(() => {
        setCurrentPage(1);
        getFundRequestReport(1);
      }, 1000);
    }

    // Cleanup function
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [filters.user_id]);

  // Auto-search when status changes
  useEffect(() => {
    setCurrentPage(1);
    getFundRequestReport(1);
  }, [filters.status]);

  // Auto-search when date filters change
  useEffect(() => {
    if (filters.from_date || filters.to_date) {
      setCurrentPage(1);
      getFundRequestReport(1);
    }
  }, [filters.from_date, filters.to_date]);

  // Pagination handlers
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      getFundRequestReport(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (paginationData?.next_page_url) {
      getFundRequestReport(currentPage + 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    getFundRequestReport(pageNumber);
  };

  // Generate page numbers for pagination
  const generatePageNumbers = () => {
    const totalPages = paginationData?.last_page || 1;
    const pages = [];
    const maxPagesToShow = 10;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  useEffect(() => {
    if (approvePopUp && filename) {
      getPaySlipPreview();
    }
  }, [approvePopUp, filename]);

  useEffect(() => {
    getFundRequestReport(1);
  }, [totaldata]);

  function getTotalFundDataCountByType(typesName) {
    if (!fundRequestReport || fundRequestReport.length === 0) {
      return 0;
    }
    const filteredReports = fundRequestReport.filter(
      (curr) => curr.status && curr.status.value === typesName,
    );
    return filteredReports.length;
  }

  function getTotalFundDataAmountByType(typesName) {
    if (!fundRequestReport || fundRequestReport.length === 0) {
      return 0;
    }
    const totalAmount = fundRequestReport.reduce((acc, curr) => {
      if (typesName === "") {
        return acc + (parseFloat(curr.amount) || 0);
      }
      if (curr.status && curr.status.value === typesName) {
        return acc + (parseFloat(curr.amount) || 0);
      }
      return acc;
    }, 0);
    return totalAmount;
  }

  return (
    <div className="p-4 mt-6 bg-white overflow-hidden">
      {isLoading && <Loader />}

      <div className="flex justify-center mb-2">
        <ReportHeading name="Fund Approve" />
      </div>

      {/* Compact Fund Summary Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-8 gap-1 overflow-x-auto pb-2 -mx-2 px-2">
        {[
          {
            label: "Total Requests",
            value: fundRequestReport?.length || 0,
            icon: <FaUsers className="w-4 h-4" />,
            color: "blue",
          },
          {
            label: "Approved",
            value: getTotalFundDataCountByType("approved"),
            icon: <FaCheckCircle className="w-4 h-4" />,
            color: "green",
          },
          {
            label: "Rejected",
            value: getTotalFundDataCountByType("rejected"),
            icon: <FaTimesCircle className="w-4 h-4" />,
            color: "red",
          },
          {
            label: "Pending",
            value: getTotalFundDataCountByType("pending"),
            icon: <FaClock className="w-4 h-4" />,
            color: "yellow",
          },
          {
            label: "Total Amount",
            value: "₹" + getTotalFundDataAmountByType(""),
            icon: <FaRupeeSign className="w-4 h-4" />,
            color: "indigo",
          },
          {
            label: "Approved Amt",
            value: "₹" + getTotalFundDataAmountByType("approved"),
            icon: <FaCheck className="w-4 h-4" />,
            color: "green",
          },
          {
            label: "Rejected Amt",
            value: "₹" + getTotalFundDataAmountByType("rejected"),
            icon: <FaTimes className="w-4 h-4" />,
            color: "red",
          },
          {
            label: "Pending Amt",
            value: "₹" + getTotalFundDataAmountByType("pending"),
            icon: <FaClock className="w-4 h-4" />,
            color: "yellow",
          },
        ].map((box, index) => (
          <div
            key={index}
            className={`
        group bg-white/80 backdrop-blur-sm 
        border border-${box.color}-200 hover:border-${box.color}-400
        p-3 rounded-xl shadow-sm hover:shadow-lg
        hover:bg-${box.color}-50 transition-all duration-200
        min-w-[85px] h-20 flex flex-col justify-between
      `}
          >
            {/* Icon + Label */}
            <div className="flex items-center gap-2 mb-1">
              <div
                className={`p-1.5 rounded-lg bg-${box.color}-100 group-hover:bg-${box.color}-200`}
              >
                {box.icon}
              </div>
              <span
                className={`text-xs font-semibold text-gray-700 truncate ${box.color}-700/90 group-hover:text-${box.color}-700`}
              >
                {box.label}
              </span>
            </div>

            {/* Value */}
            <p
              className={`text-lg font-bold text-gray-900 ${box.color}-900 group-hover:${box.color}-700 truncate`}
            >
              {box.value}
            </p>
          </div>
        ))}
      </div>

      {/* Filter Section */}
      <div className="mt-2 bg-gray-50 p-2 rounded-md border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {/* From Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Date
            </label>
            <input
              type="date"
              value={filters.from_date}
              onChange={(e) => handleFilterChange("from_date", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* To Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              To Date
            </label>
            <input
              type="date"
              value={filters.to_date}
              onChange={(e) => handleFilterChange("to_date", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Status Filter - Auto Search */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>

          {/* User ID Search - Debounced Auto Search */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              User ID
            </label>
            <input
              type="text"
              value={filters.user_id}
              onChange={(e) =>
                handleFilterChange("user_id", e.target.value.toUpperCase())
              }
              placeholder="EX: APID***"
              className="border border-gray-300 p-1 rounded-md w-full uppercase focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
            {filters.user_id.length > 0 && filters.user_id.length < 3 && (
              <p className="text-xs text-orange-500 mt-1">
                Type at least 3 characters to search
              </p>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 mt-2">
          <button
            onClick={handleSearch}
            className="bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition"
          >
            Manual Search
          </button>
          <button
            onClick={handleResetFilters}
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 transition"
          >
            Reset All Filters
          </button>
        </div>

        {/* Search Status Indicator */}
        {/* {isLoading && (
          <div className="mt-3 text-sm text-blue-600 flex items-center gap-2">
            <span className="animate-spin">⏳</span> Searching...
          </div>
        )} */}
      </div>

      {/* Records Per Page */}
      <div className="mt-2 flex items-center gap-4">
        <label className="text-sm font-medium text-gray-700">
          Records per page:
        </label>
        <select
          className="border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={totaldata}
          onChange={(e) => {
            setTotalData(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        {paginationData?.total > 0 && (
          <span className="text-sm text-gray-600">
            Showing {paginationData?.from || 0} to {paginationData?.to || 0} of{" "}
            {paginationData?.total || 0} entries
          </span>
        )}
      </div>

      {/* Popup Modal */}
      <PopMenu
        onClose={() => {
          setFileName("");
          setPaySlip("");
          setApprovePopUp(false);
          setRemarks("");
        }}
        visible={approvePopUp}
        title="Fund Approve"
        className="!h-[90%] overflow-y-auto w-full md:w-2/3 lg:w-1/3 overflow-x-hidden"
      >
        <div>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-1 justify-around my-4">
            <p className="text-sm font-bold text-blue-900 text-center">
              User Id: {selectedUserId}
            </p>
            <p className="text-sm font-bold text-blue-900 text-center">
              User Name: {selectedName}
            </p>
            <p className="text-sm font-bold text-blue-900 text-center">
              Amount: ₹{amount}
            </p>
          </div>

          {isImagePreview ? (
            <ImageSketlton />
          ) : (
            <img
              src={paySlip}
              alt="Payment Slip"
              className="h-3/4 w-full object-contain"
            />
          )}

          <div className="h-40 w-full shadow flex flex-col my-5 border rounded">
            <label htmlFor="remarks" className="font-medium p-2">
              Remarks
            </label>
            <textarea
              name="remarks"
              id="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="flex-1 border-slate-400 border p-2 outline-none"
              placeholder="Enter your remarks here..."
            />
          </div>

          <div className="flex justify-around px-3">
            <Button
              type="button"
              onClick={() => handleFundStatus("rejected")}
              text="Reject"
              className="bg-red-800 rounded-sm text-white py-2 px-4 font-semibold my-2 hover:bg-red-700"
            />
            <Button
              type="button"
              onClick={() => handleFundStatus("approved")}
              text="Approve"
              className="bg-green-500 rounded-sm text-white py-2 px-4 font-semibold my-2 hover:bg-green-600"
            />
          </div>
        </div>
      </PopMenu>

      {/* Fund Request Table */}
      <div className="mt-6 overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-md">
          <thead className="bg-blue-600 text-white">
            <tr>
              {[
                "SN.",
                "User ID",
                "Name",
                "Mobile",
                "Amount",
                "UTR",
                "Order ID",
                "Status",
                "Remarks",
                "Request Date",
                "Action",
              ].map((heading, index) => (
                <th key={index} className="p-2 text-left whitespace-nowrap">
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fundRequestReport.length > 0 ? (
              fundRequestReport.map((fund, index) => (
                <tr key={fund.id} className="hover:bg-gray-50">
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {(currentPage - 1) * totaldata + index + 1}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.user?.user_id}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    <span className="font-semibold"> {fund?.user?.name} </span>
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.user?.mobile_number}
                  </td>

                  <td
                    className={`p-2 whitespace-nowrap text-sm font-medium border border-gray-300 text-center ${
                      fund?.status?.value === "pending"
                        ? "text-yellow-600"
                        : fund?.status?.value === "rejected"
                          ? "text-red-600"
                          : "text-green-600"
                    }`}
                  >
                    ₹{fund?.amount}
                  </td>

                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.transaction_ids?.[0]?.utr || "-"}
                  </td>
                  <td className="p-2 whitespace-nowrap text-xs font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.transaction_ids?.[0]?.order_id || "-"}
                  </td>
                  <td
                    className={`p-2 whitespace-nowrap text-sm font-bold border border-gray-300 text-center uppercase ${
                      fund?.status?.value === "pending"
                        ? "text-yellow-600"
                        : fund?.status?.value === "rejected"
                          ? "text-red-600"
                          : "text-green-600"
                    }`}
                  >
                    {fund?.status?.value}
                  </td>
                  <td className="p-2 whitespace-nowrap text-xs font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.remarks || "-"}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.created_at?.slice(0, 10)}
                  </td>
                  <td className="p-2 whitespace-nowrap border border-gray-300 text-center">
                    {fund?.status?.value === "pending" ? (
                      <button
                        className="bg-blue-500 text-white rounded-md px-3 py-1 hover:bg-blue-600 transition"
                        onClick={() => {
                          setSelectedName(fund?.user?.name);
                          setSelectedUserId(fund?.user?.user_id);
                          setAmount(fund?.amount);
                          setFileName(fund?.pay_slip?.[0]?.file);
                          setSelectedFundId(fund?.id);
                          setApprovePopUp(true);
                        }}
                      >
                        Update
                      </button>
                    ) : (
                      <span
                        className={`px-3 py-1 rounded text-white text-sm ${
                          fund?.status?.value === "rejected"
                            ? "bg-red-600"
                            : "bg-green-600"
                        }`}
                      >
                        {fund?.status?.value}
                      </span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="p-8 text-center">
                  <div className="flex flex-col items-center justify-center text-gray-500">
                    <FaInbox className="text-5xl mb-2" />
                    <p className="text-xl">No Data Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {paginationData?.total > 0 && (
        <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-600">
            Page {currentPage} of {paginationData?.last_page || 1}
          </div>

          <div className="flex gap-2 flex-wrap justify-center">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-900 text-white hover:bg-blue-800"
              }`}
            >
              Previous
            </button>

            {generatePageNumbers().map((pageNum, index) => (
              <button
                key={index}
                onClick={() =>
                  typeof pageNum === "number" && handlePageClick(pageNum)
                }
                disabled={pageNum === "..."}
                className={`px-3 py-2 rounded-md ${
                  pageNum === currentPage
                    ? "bg-blue-900 text-white"
                    : pageNum === "..."
                      ? "bg-white text-gray-500 cursor-default"
                      : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-100"
                }`}
              >
                {pageNum}
              </button>
            ))}

            <button
              onClick={handleNextPage}
              disabled={!paginationData?.next_page_url}
              className={`px-4 py-2 rounded-md ${
                !paginationData?.next_page_url
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-900 text-white hover:bg-blue-800"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FundApprove;
